/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/BarcodeTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
/** @hidden */
export const CharacterEncodingValues = [
    'UNKNOWN',
    'ASCII',
    'ISO_8859_PART1',
    'ISO_8859_PART2',
    'ISO_8859_PART3',
    'ISO_8859_PART4',
    'ISO_8859_PART5',
    'ISO_8859_PART6',
    'ISO_8859_PART7',
    'ISO_8859_PART8',
    'ISO_8859_PART9',
    'ISO_8859_PART10',
    'ISO_8859_PART11',
    'ISO_8859_PART13',
    'ISO_8859_PART14',
    'ISO_8859_PART15',
    'ISO_8859_PART16',
    'CP_437',
    'CP_1250',
    'CP_1251',
    'CP_1252',
    'CP_1256',
    'SHIFT_JIS',
    'BIG_5',
    'GB_2312',
    'GB_18030',
    'EUC_JP',
    'EUC_KR',
    'UTF_16_BE',
    'UTF_8',
    'UTF_16_LE',
    'UTF_32_BE',
    'UTF_32_LE',
    'BINARY',
];
/**
A character encoding for a given range of bytes.
*/
export class RangeEncoding {
    /** @param source {@displayType `DeepPartial<RangeEncoding>`} */
    constructor(source = {}) {
        if (source.start !== undefined) {
            this.start = source.start;
        }
        else {
            throw new Error('start must be present in constructor argument');
        }
        if (source.end !== undefined) {
            this.end = source.end;
        }
        else {
            throw new Error('end must be present in constructor argument');
        }
        if (source.encoding !== undefined) {
            this.encoding = source.encoding;
        }
        else {
            throw new Error('encoding must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            start: this.start,
            end: this.end,
            encoding: this.encoding,
        };
    }
}
/**
The structured append mode can be used to split a message across multiple barcodes.
*/
export class StructuredAppendInfo {
    /** @param source {@displayType `DeepPartial<StructuredAppendInfo>`} */
    constructor(source = {}) {
        if (source.count !== undefined) {
            this.count = source.count;
        }
        else {
            throw new Error('count must be present in constructor argument');
        }
        if (source.index !== undefined) {
            this.index = source.index;
        }
        else {
            throw new Error('index must be present in constructor argument');
        }
        if (source.id !== undefined) {
            this.id = source.id;
        }
        else {
            throw new Error('id must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            count: this.count,
            index: this.index,
            id: this.id,
        };
    }
}
/** @hidden */
export const BarcodeFormatValues = [
    'NONE',
    'AZTEC',
    'CODABAR',
    'CODE_39',
    'CODE_93',
    'CODE_128',
    'DATA_MATRIX',
    'EAN_8',
    'EAN_13',
    'ITF',
    'MAXI_CODE',
    'PDF_417',
    'QR_CODE',
    'DATABAR',
    'DATABAR_EXPANDED',
    'UPC_A',
    'UPC_E',
    'MSI_PLESSEY',
    'IATA_2_OF_5',
    'INDUSTRIAL_2_OF_5',
    'CODE_25',
    'MICRO_QR_CODE',
    'USPS_INTELLIGENT_MAIL',
    'ROYAL_MAIL',
    'JAPAN_POST',
    'ROYAL_TNT_POST',
    'AUSTRALIA_POST',
    'DATABAR_LIMITED',
    'MICRO_PDF_417',
    'GS1_COMPOSITE',
    'RMQR_CODE',
    'CODE_11',
    'CODE_32',
    'PHARMA_CODE',
    'PHARMA_CODE_TWO_TRACK',
    'PZN_7',
    'PZN_8',
];
/**
Lists of barcode formats to decode.
*/
export class BarcodeFormats {
    /** @param source {@displayType `DeepPartial<BarcodeFormats>`} */
    constructor(source = {}) { }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (BarcodeFormats) {
    /**
      List of 1D barcode formats.
      */
    BarcodeFormats.oned = [
        'CODABAR',
        'CODE_11',
        'CODE_25',
        'CODE_32',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'DATABAR',
        'DATABAR_EXPANDED',
        'DATABAR_LIMITED',
        'EAN_8',
        'EAN_13',
        'IATA_2_OF_5',
        'INDUSTRIAL_2_OF_5',
        'ITF',
        'MSI_PLESSEY',
        'PHARMA_CODE',
        'PZN_7',
        'PZN_8',
        'UPC_A',
        'UPC_E',
    ];
    /**
      List of 2D barcode formats.
      */
    BarcodeFormats.twod = [
        'AZTEC',
        'DATA_MATRIX',
        'MAXI_CODE',
        'MICRO_QR_CODE',
        'MICRO_PDF_417',
        'PDF_417',
        'QR_CODE',
        'RMQR_CODE',
    ];
    /**
      List of postal barcode formats.
      */
    BarcodeFormats.postal = [
        'AUSTRALIA_POST',
        'JAPAN_POST',
        'ROYAL_MAIL',
        'ROYAL_TNT_POST',
        'USPS_INTELLIGENT_MAIL',
    ];
    /**
      List of pharmaceutical barcode formats.
      */
    BarcodeFormats.pharma = ['CODE_32', 'PHARMA_CODE', 'PHARMA_CODE_TWO_TRACK', 'PZN_7', 'PZN_8'];
    /**
      List of common barcode formats.
      */
    BarcodeFormats.common = [
        'AZTEC',
        'CODABAR',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'DATA_MATRIX',
        'DATABAR',
        'DATABAR_EXPANDED',
        'DATABAR_LIMITED',
        'EAN_13',
        'EAN_8',
        'ITF',
        'PDF_417',
        'QR_CODE',
        'UPC_A',
        'UPC_E',
    ];
    /**
      List of all barcode formats.
      */
    BarcodeFormats.all = [
        'AUSTRALIA_POST',
        'AZTEC',
        'CODABAR',
        'CODE_11',
        'CODE_25',
        'CODE_32',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'DATA_MATRIX',
        'DATABAR',
        'DATABAR_EXPANDED',
        'DATABAR_LIMITED',
        'EAN_13',
        'EAN_8',
        'GS1_COMPOSITE',
        'IATA_2_OF_5',
        'INDUSTRIAL_2_OF_5',
        'ITF',
        'JAPAN_POST',
        'MAXI_CODE',
        'MICRO_PDF_417',
        'MICRO_QR_CODE',
        'MSI_PLESSEY',
        'PDF_417',
        'PHARMA_CODE',
        'PHARMA_CODE_TWO_TRACK',
        'PZN_7',
        'PZN_8',
        'QR_CODE',
        'RMQR_CODE',
        'ROYAL_MAIL',
        'ROYAL_TNT_POST',
        'UPC_A',
        'UPC_E',
        'USPS_INTELLIGENT_MAIL',
    ];
})(BarcodeFormats || (BarcodeFormats = {}));
/** @hidden */
export const Gs1HandlingValues = [
    'PARSE',
    'VALIDATE_STRUCTURE',
    'DECODE_STRUCTURE',
    'VALIDATE_FULL',
    'DECODE_FULL',
];
/** @hidden */
export const UpcEanExtensionBehaviorValues = [
    'REQUIRE_2',
    'REQUIRE_5',
    'REQUIRE_ANY',
    'IGNORE',
    'ALLOW_2',
    'ALLOW_5',
    'ALLOW_ANY',
];
/** @hidden */
export const OneDConfirmationModeValues = [
    'NONE',
    'MINIMAL',
    'MODERATE',
    'THOROUGH',
];
//# sourceMappingURL=BarcodeTypes.js.map